import React from "react";
import { CheckCircle2, RefreshCw, Webhook } from "lucide-react";

function WebhookHeader({ refreshing, onRefresh, isVerified }) {
  return (
    <div className="relative overflow-hidden border-b border-[#d8e7ed] bg-[linear-gradient(112deg,#ffffff_0%,#f6fcff_62%,#edf8fd_100%)] px-4 py-5 sm:px-5 lg:px-6 dark:border-dark-border dark:bg-[linear-gradient(112deg,#142330_0%,#153247_60%,#123a55_100%)]">
      <div className="pointer-events-none absolute -right-10 -top-14 h-36 w-36 rounded-full border border-[#b9dff0]/80" />
      <div className="relative flex items-center gap-3">

        {/* Icon */}
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] border border-[#b9dff0] bg-white/85 text-[#147db5] shadow-[inset_0_1px_0_white] dark:border-dark-primary/45 dark:bg-dark-soft-blue dark:text-dark-primary">
          <Webhook size={18} strokeWidth={1.75} />
        </div>

        {/* Content */}
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
          <h2 className="text-[15px] font-bold tracking-[-0.02em] text-[#173044] dark:text-dark-text-primary">
            Event delivery
          </h2>
          <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[8px] font-bold ${isVerified ? "border-[#bfe0d1] bg-[#eaf7f0] text-[#2f765d] dark:border-[#3b604f] dark:bg-[#1d382d] dark:text-[#7dcaab]" : "border-[#ead9b8] bg-[#fff8e9] text-[#946b2d] dark:border-[#5c4a2d] dark:bg-[#302819] dark:text-[#dcb276]"}`}>
            <CheckCircle2 size={9} />
            {isVerified ? "Verified" : "Needs attention"}
          </span>
          </div>

          <p className="mt-1 text-[9px] font-medium leading-4 text-[#607787] sm:text-[10px] dark:text-dark-text-secondary">
            Credentials and health for events sent from Meta to this workspace.
          </p>
        </div>

        {/* Refresh */}
        <button
          type="button"
          onClick={onRefresh}
          disabled={refreshing}
          className="ml-auto flex h-9 shrink-0 items-center gap-2 rounded-xl border border-[#c9dce4] bg-white/85 px-3 text-[9px] font-bold text-[#5f7585] shadow-sm transition hover:border-[#9bcbe2] hover:bg-white hover:text-[#147db5] disabled:cursor-not-allowed disabled:opacity-60 dark:border-dark-border dark:bg-dark-surface dark:text-dark-text-secondary dark:hover:border-dark-primary dark:hover:text-dark-primary"
        >
          <RefreshCw
            size={12}
            className={refreshing ? "animate-spin" : ""}
          />

          <span className="hidden sm:inline">{refreshing ? "Refreshing..." : "Refresh status"}</span>
        </button>
      </div>
    </div>
  );
}

export default WebhookHeader;
